var map = {
	"./Videos/Apps_01_presentation.mp4": 7033,
	"./Videos/Apps_02_design_system.mp4": 2564,
	"./Videos/Apps_03_programming.mp4": 5612,
	"./Videos/Apps_04_designing.mp4": 4430,
	"./Videos/Play_01_presentation.mp4": 3171,
	"./Videos/Play_02_design_system.mp4": 5722,
	"./Videos/Play_03_infiniteBG.mp4": 8456,
	"./Videos/Play_04_scenes.mp4": 875,
	"./Videos/Play_05_preconfig.mp4": 4842,
	"./Videos/Smartbooqs_01_presentation.mp4": 9856,
	"./Videos/Smartbooqs_02_Actividades.mp4": 2268,
	"./Videos/Smartbooqs_03_Evaluation.mp4": 4496,
	"./Videos/Smartbooqs_04_basic_options.mp4": 5590,
	"./Videos/Smartbooqs_05_basic_advanced.mp4": 4407,
	"./Videos/bMaker_01_Alumno_ Ejemplo_de_sesion.mp4": 6424,
	"./Videos/bMaker_02_Alumno_ Grupos.mp4": 2097,
	"./Videos/bMaker_03.1_Docente_ Derechos.mp4": 3564,
	"./Videos/bMaker_03.2_Docente_ Derechos.mp4": 6211,
	"./Videos/bMaker_04.1_Alumno_Logro.mp4": 4851,
	"./Videos/bMaker_04.2_Alumno_Logro.mp4": 8918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2358;